import React from "react";
import { Modal } from "antd";

const UIImagePreview = ({ onClose, visible, image }) => {
  return (
    <>
      <Modal
        centered
        open={visible}
        footer={false}
        width={800}
        onCancel={onClose}
        style={{ borderRadius: 15, width: 100 }}
      >
        <div>
          <img alt="Preview Image" width={"100%"} src={image} />
        </div>
      </Modal>
    </>
  );
};

export default UIImagePreview;
